export default function displaySideNavScreen({screenToDisplay, screenName, backButtonScreen, backButtonScreenName, back }) {
  const $titleBar = $('.rwnav-title');

  // Make the title bar visible unless we're displaying the top-level menu screen
  $titleBar.toggleClass('hide', screenToDisplay === 'menu');

  // Set the screen name on the title bar
  $('#rwnav-title-name').text(screenName);

  // Add the back button screen to the back screens array
  const backScreens = $('#rwnav-back').data('screens') || [];
  const highestScreenLevel = backScreens.length === 0 ? 0 : Math.max(...backScreens.map(s => s.level));

  if (!back) {
    backScreens.push({
      screen: backButtonScreen,
      screenName: backButtonScreenName,
      level: highestScreenLevel + 1,
    });
    $('#rwnav-back').data('screens', backScreens);  
  }

  $('.rwnav-screen').removeClass('is-open');
  $(`.rwnav-screen[data-list="${screenToDisplay}"]`).addClass('is-open');
}
